module.exports = ".menu-column {\n  height: 100vh;\n  padding: 3rem 0 0 0;\n  background-color: #EAEAEA; }\n\n.content-column {\n  padding: 3.5rem 0.5rem 0 0.5rem; }\n\nmenu {\n  margin-top: 0;\n  padding-left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 565
// module chunks = 1